// extracted by mini-css-extract-plugin
module.exports = {"cardListWrap":"CardList_cardListWrap__26Z_1"};